export default function () {
  return {
    flags: []
  };
}